import {useIntl} from 'react-intl'
import {MenuItem} from './MenuItem'
import {MenuInnerWithSub} from './MenuInnerWithSub'
import {MegaMenu} from './MegaMenu'

export function MenuInner() {
  const intl = useIntl()
  return (
    <>
      <MenuItem title={intl.formatMessage({id: 'MENU.SERVICES'})} to='/services' />
      <MenuItem title={intl.formatMessage({id: 'MENU.RIDES'})} to='/rides' />
      <MenuItem title={intl.formatMessage({id: 'MENU.RIDES_CALENDAR'})} to='/calendar-rides' />
      <MenuItem title={intl.formatMessage({id: 'MENU.MEANS'})} to='/means' />
      <MenuItem title={intl.formatMessage({id: 'MENU.MEANS_CALENDAR'})} to='/calendar-means' />
      <MenuItem title={intl.formatMessage({id: 'MENU.DRIVERS'})} to='/drivers' />
      <MenuItem title={intl.formatMessage({id: 'MENU.DRIVERS_CALENDAR'})} to='/calendar-drivers' />
      <MenuItem title={intl.formatMessage({id: 'MENU.PROVIDERS'})} to='/providers' />
      <MenuItem title={intl.formatMessage({id: 'MENU.REFERENTS'})} to='/referents' />
      <MenuItem title={intl.formatMessage({id: 'MENU.CLIENTS'})} to='/clients' />
    </>
  )
}
